export default "__VITE_ASSET__CImqJWyF__"